import { useSyncExternalStore } from "react";
import { Navigate, Outlet } from "react-router-dom";

const SESSION_CHANGED = "simatomic-session-changed";
const sessionToken = () => localStorage.getItem("accessToken") || "";

function subscribeToSession(callback) {
  const events = ["storage", "focus", "pageshow", SESSION_CHANGED];
  events.forEach((event) => window.addEventListener(event, callback));
  return () => events.forEach((event) => window.removeEventListener(event, callback));
}

export function notifySessionChange() {
  window.dispatchEvent(new Event(SESSION_CHANGED));
}

export function clearPortalSession() {
  ["accessToken", "userRole", "userStatus", "demoTourActive", "demoTourStep"].forEach((key) => localStorage.removeItem(key));
  Object.keys(localStorage).filter((key) => key.startsWith("mdscaleway_")).forEach((key) => localStorage.removeItem(key));
  Object.keys(sessionStorage).filter((key) => key.startsWith("simatomicProject:")).forEach((key) => sessionStorage.removeItem(key));
  notifySessionChange();
}

export function RequirePortalSession() {
  const token = useSyncExternalStore(subscribeToSession, sessionToken, () => "");
  // Replacing the outlet also discards the previous account's page state when
  // another tab logs in with a different account.
  return token ? <Outlet key={token} /> : <Navigate to="/login" replace />;
}
